import type { FormSelectOption } from '@practium/ui';

export const BRAZILIAN_STATES: FormSelectOption[] = [
	{ value: 'AC', label: 'Acre' },
	{ value: 'AL', label: 'Alagoas' },
	{ value: 'AP', label: 'Amapá' },
	{ value: 'AM', label: 'Amazonas' },
	{ value: 'BA', label: 'Bahia' },
	{ value: 'CE', label: 'Ceará' },
	{ value: 'DF', label: 'Distrito Federal' },
	{ value: 'ES', label: 'Espírito Santo' },
	{ value: 'GO', label: 'Goiás' },
	{ value: 'MA', label: 'Maranhão' },
	{ value: 'MT', label: 'Mato Grosso' },
	{ value: 'MS', label: 'Mato Grosso do Sul' },
	{ value: 'MG', label: 'Minas Gerais' },
	{ value: 'PA', label: 'Pará' },
	{ value: 'PB', label: 'Paraíba' },
	{ value: 'PR', label: 'Paraná' },
	{ value: 'PE', label: 'Pernambuco' },
	{ value: 'PI', label: 'Piauí' },
	{ value: 'RJ', label: 'Rio de Janeiro' },
	{ value: 'RN', label: 'Rio Grande do Norte' },
	{ value: 'RS', label: 'Rio Grande do Sul' },
	{ value: 'RO', label: 'Rondônia' },
	{ value: 'RR', label: 'Roraima' },
	{ value: 'SC', label: 'Santa Catarina' },
	{ value: 'SP', label: 'São Paulo' },
	{ value: 'SE', label: 'Sergipe' },
	{ value: 'TO', label: 'Tocantins' },
];

export const SOIL_TEXTURE_OPTIONS: FormSelectOption[] = [
	{ value: 'arenosa', label: 'Arenosa' },
	{ value: 'media', label: 'Média' },
	{ value: 'argilosa', label: 'Argilosa' },
	{ value: 'muitoArgilosa', label: 'Muito Argilosa' },
];

export const SOIL_TEXTURE_MODE_OPTIONS: FormSelectOption[] = [
	{ value: 'Prem', label: 'P-remanescente' },
	{ value: 'texture', label: 'Classe textural' },
	{ value: 'clay', label: '% Argila' },
];

export const ANALYSIS_CULTURE_OPTIONS: FormSelectOption[] = [
	{ value: 'coffeeArabica', label: 'Café Arábica' },
	{ value: 'coffeeConilon', label: 'Café Conilon' },
];

export const SEASON_OPTIONS: FormSelectOption[] = [
	{ value: 'summer', label: 'Verão' },
	{ value: 'autumn', label: 'Outono' },
	{ value: 'winter', label: 'Inverno' },
	{ value: 'spring', label: 'Primavera' },
];

export const BIENNIAL_OPTIONS: FormSelectOption[] = [
	{ value: 'on', label: 'On (produção)' },
	{ value: 'off', label: 'Off (descanso)' },
];

export const STATUS_OPTIONS: FormSelectOption[] = [
	{ value: 'Pendente', label: 'Pendente' },
	{ value: 'Realizada', label: 'Realizada' },
	{ value: 'A vencer', label: 'A vencer' },
];

export const ANALYSIS_UNIT_OPTIONS: FormSelectOption[] = [
	{ value: 'g/kg', label: 'g/kg' },
	{ value: 'mg/kg', label: 'mg/kg' },
	{ value: 'mg/dm3', label: 'mg/dm³' },
	{ value: 'cmolc/dm3', label: 'cmolc/dm³' },
	{ value: 'g/dm3', label: 'g/dm³' },
	{ value: 'mg/L', label: 'mg/L' },
	{ value: 'pH', label: 'pH' },
	{ value: '%', label: '%' },
	{ value: 'ratio', label: 'Razão' },
];

export const UNIT_OPTIONS_MG_DM3: FormSelectOption[] = [
	{ value: 'mg/dm3', label: 'mg/dm³' },
	{ value: 'mg/kg', label: 'mg/kg' },
	{ value: 'mg/L', label: 'mg/L' },
	{ value: 'g/dm3', label: 'g/dm³' },
];

export const UNIT_OPTIONS_K_NA: FormSelectOption[] = [
	{ value: 'mg/dm3', label: 'mg/dm³' },
	{ value: 'mg/kg', label: 'mg/kg' },
	{ value: 'mg/L', label: 'mg/L' },
	{ value: 'g/dm3', label: 'g/dm³' },
	{ value: 'cmolc/dm3', label: 'cmolc/dm³' },
	{ value: 'mmolc/dm3', label: 'mmolc/dm³' },
];

export const UNIT_OPTIONS_CA_MG_AL: FormSelectOption[] = [
	{ value: 'cmolc/dm3', label: 'cmolc/dm³' },
	{ value: 'mmolc/dm3', label: 'mmolc/dm³' },
	{ value: 'mg/dm3', label: 'mg/dm³' },
];

export const UNIT_OPTIONS_HAL_SB_CTC: FormSelectOption[] = [
	{ value: 'cmolc/dm3', label: 'cmolc/dm³' },
	{ value: 'mmolc/dm3', label: 'mmolc/dm³' },
];

export const UNIT_OPTIONS_PERCENT: FormSelectOption[] = [
	{ value: '%', label: '%' },
	{ value: 'dag/kg', label: 'dag/kg' },
	{ value: 'g/100g', label: 'g/100g' },
	{ value: 'g/kg', label: 'g/kg' },
	{ value: 'mg/kg', label: 'mg/kg' },
	{ value: 'fraction/fracao', label: 'fraction/fração' },
];

export const UNIT_OPTIONS_MO: FormSelectOption[] = [
	...UNIT_OPTIONS_PERCENT,
	{ value: 'g/dm3', label: 'g/dm³' },
];

export const UNIT_OPTIONS_PH: FormSelectOption[] = [
	{ value: 'pH', label: 'pH' },
];

export const UNIT_OPTIONS_PREM: FormSelectOption[] = [
	{ value: 'mg/L', label: 'mg/L' },
	{ value: 'mg/dm3', label: 'mg/dm³' },
	{ value: 'mg/kg', label: 'mg/kg' },
];

export const UNIT_OPTIONS_CAMG: FormSelectOption[] = [
	{ value: 'ratio', label: 'Razão' },
	{ value: 'relacao', label: 'Relação' },
	{ value: 'razao', label: 'Razão (texto)' },
	{ value: 'semiunidade', label: 'Semiunidade' },
	{ value: 'adimensional', label: 'Adimensional' },
];

export const UNIT_OPTIONS_MACRO_FOLIAR: FormSelectOption[] = [
	{ value: 'g/kg', label: 'g/kg' },
	{ value: '%', label: '%' },
	{ value: 'mg/kg', label: 'mg/kg' },
];

export const UNIT_OPTIONS_MICRO_FOLIAR: FormSelectOption[] = [
	{ value: 'mg/kg', label: 'mg/kg' },
	{ value: 'g/kg', label: 'g/kg' },
	{ value: '%', label: '%' },
];

export const DEFAULT_SOIL_UNITS = {
	Prem: 'mg/L',
	clay: '%',
	Pm1: 'mg/dm3',
	Pres: 'mg/dm3',
	K: 'mg/dm3',
	Ca: 'cmolc/dm3',
	Mg: 'cmolc/dm3',
	S: 'mg/dm3',
	Na: 'mg/dm3',
	B: 'mg/dm3',
	Cu: 'mg/dm3',
	Fe: 'mg/dm3',
	Mn: 'mg/dm3',
	Zn: 'mg/dm3',
	MO: '%',
	pHagua: 'pH',
	pHCaCl2: 'pH',
	Al: 'cmolc/dm3',
	HAl: 'cmolc/dm3',
	SB: 'cmolc/dm3',
	ctcE: 'cmolc/dm3',
	ctcT: 'cmolc/dm3',
	CaMg: 'ratio',
	satSB: '%',
	satAl: '%',
	satCa: '%',
	satMg: '%',
	satK: '%',
} as const;

export const DEFAULT_PLANT_UNITS = {
	N: 'g/kg',
	P: 'g/kg',
	K: 'g/kg',
	Ca: 'g/kg',
	Mg: 'g/kg',
	S: 'g/kg',
	B: 'mg/kg',
	Cu: 'mg/kg',
	Fe: 'mg/kg',
	Mn: 'mg/kg',
	Zn: 'mg/kg',
} as const;

export const DEFAULT_SOIL_FORM = {
	name: '',
	state: '',
	sampledAt: '',
	property: '',
	area: '',
	sector: [] as string[],
	note: '',
	textureMode: '' as '' | 'Prem' | 'texture' | 'clay',
	Prem: '',
	texture: '',
	clay: '',
	Pm1: '',
	Pres: '',
	K: '',
	Ca: '',
	Mg: '',
	S: '',
	Na: '',
	B: '',
	Cu: '',
	Fe: '',
	Mn: '',
	Zn: '',
	MO: '',
	pHagua: '',
	pHCaCl2: '',
	Al: '',
	HAl: '',
	SB: '',
	ctcE: '',
	ctcT: '',
	CaMg: '',
	satSB: '',
	satAl: '',
	satCa: '',
	satMg: '',
	satK: '',
	units: { ...DEFAULT_SOIL_UNITS },
};

export const DEFAULT_PLANT_FORM = {
	name: '',
	region: '',
	sampleAt: '',
	property: '',
	area: '',
	sector: [] as string[],
	culture: '',
	season: '',
	biennial: '',
	note: '',
	N: '',
	P: '',
	K: '',
	Ca: '',
	Mg: '',
	S: '',
	B: '',
	Cu: '',
	Fe: '',
	Mn: '',
	Zn: '',
	units: { ...DEFAULT_PLANT_UNITS },
};
